import {useMutation, useQueryClient} from '@tanstack/react-query';
import contractUpdaters from '@/api/updaters/contracts';

function useBatchUpdateContractDueDate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['contracts', 'batchUpdateDueDate'],
    mutationFn: contractUpdaters.batchUpdateDueDate,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
    },
  });
}

export default useBatchUpdateContractDueDate;
